module.exports = __webpack_public_path__ + "img/uganda.863b41cf.svg";